import React from 'react';
import { DollarSignIcon, AwardIcon, ClockIcon, SearchIcon, ShieldIcon, UsersIcon } from 'lucide-react';
export function WhyChooseUs() {
  const valueProps = [{
    title: 'No Hidden Costs',
    description: 'Transparent pricing with no surprise fees. Your quote is your final price.',
    icon: <DollarSignIcon className="h-8 w-8 text-amber-500" data-id="element-327" />
  }, {
    title: 'Lifetime Workmanship Warranty',
    description: 'We stand behind every roof we install with our industry-leading warranty.',
    icon: <AwardIcon className="h-8 w-8 text-amber-500" data-id="element-328" />
  }, {
    title: 'Completed in 3-5 Days',
    description: 'Most residential roofs completed in under a week with minimal disruption.',
    icon: <ClockIcon className="h-8 w-8 text-amber-500" data-id="element-329" />
  }, {
    title: 'Free Roof Inspection',
    description: 'No-obligation professional inspection with detailed findings report.',
    icon: <SearchIcon className="h-8 w-8 text-amber-500" data-id="element-330" />
  }, {
    title: 'Insurance Claim Experts',
    description: 'We work directly with your insurance to maximize your claim coverage.',
    icon: <ShieldIcon className="h-8 w-8 text-amber-500" data-id="element-331" />
  }, {
    title: 'Family-Owned & Local',
    description: 'Proudly serving our community with the care of a family business.',
    icon: <UsersIcon className="h-8 w-8 text-amber-500" data-id="element-332" />
  }];
  return <section className="py-16 md:py-24 bg-slate-900" data-id="element-333">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-334">
        <div className="text-center mb-16" data-id="element-335">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-336">
            Why Homeowners Trust ProRoof
          </h2>
          <p className="text-xl text-slate-400 max-w-2xl mx-auto" data-id="element-337">
            We deliver exceptional quality and service that sets us apart from
            the rest.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-12 mb-16" data-id="element-338">
          {valueProps.map((prop, index) => <div key={index} className="flex flex-col items-start" data-id="element-339">
              <div className="bg-slate-800 p-4 rounded-xl mb-6" data-id="element-340">
                {prop.icon}
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-341">
                {prop.title}
              </h3>
              <p className="text-slate-400 leading-relaxed" data-id="element-342">
                {prop.description}
              </p>
            </div>)}
        </div>

        {/* Mini Trust Strip */}
        <div className="pt-12 border-t border-slate-800" data-id="element-343">
          <div className="flex flex-wrap justify-center gap-8 md:gap-16 opacity-60" data-id="element-344">
            <span className="text-slate-300 font-semibold tracking-wider uppercase text-sm" data-id="element-345">
              Top Rated on Google
            </span>
            <span className="text-slate-300 font-semibold tracking-wider uppercase text-sm" data-id="element-346">
              A+ BBB Rating
            </span>
            <span className="text-slate-300 font-semibold tracking-wider uppercase text-sm" data-id="element-347">
              Fully Licensed
            </span>
            <span className="text-slate-300 font-semibold tracking-wider uppercase text-sm" data-id="element-348">
              Fully Insured
            </span>
          </div>
        </div>
      </div>
    </section>;
}